import BlockContent from '@sanity/block-content-to-react'
import imageUrlBuilder from '@sanity/image-url'
import React, { Fragment } from 'react'
import styled from 'styled-components'
import Lightbox from '../components/Lightbox'

const Img = styled.img`
  border: 8px solid #fff;
  border-radius: 4px;
  max-width: 100%;
`

const link = dofollowWhitelist => props => (
  <a
    href={props.mark.href}
    target={
      props.mark.href.startsWith('/') && !props.mark.href.startsWith('/go')
        ? '_self'
        : '_blank'
    }
    rel={`noopener ${
      dofollowWhitelist.some(domain =>
        props.mark.href.toLowerCase().includes(domain.toLowerCase())
      ) || props.mark.href.startsWith('/')
        ? ''
        : 'noreferrer nofollow'
    }`}
  >
    {props.children}
  </a>
)

const mailto = (email, domain) => props => {
  const { address = email, text } = props.mark
  const atIndex = address.indexOf('@')

  const fulladdress =
    address +
    (atIndex === -1
      ? `@${domain.toLowerCase()}`
      : atIndex === address.length - 1
      ? domain.toLowerCase()
      : '')

  return <a href={`mailto:${fulladdress}`}>{text || fulladdress}</a>
}

const sitename = site => props => {
  const { nameField, wrapLink } = props.mark
  const element = wrapLink ? 'a' : 'span'
  const wrapperProps = wrapLink ? { href: site.url } : null

  return React.createElement(element, wrapperProps, site[nameField])
}

const gamename = game => props => (
  <span>{props.format === 'long' ? game.name : game.shortName}</span>
)

const Figure = styled.figure`
  margin: 20px 0;
`

const image = (builder, marks) => props => {
  const src = builder
    .image(props.node)
    .withOptions(props.imageOptions)
    .url()

  const image = (
    <Fragment>
      <Img src={src} alt={props.node.caption} />
      {props.node.title ? (
        <BlockContent
          blocks={props.node.title}
          serializers={{
            marks,
          }}
        />
      ) : null}
    </Fragment>
  )

  return <div>{props.isInline ? image : <Figure>{image}</Figure>}</div>
}

const InlineDiv = styled.div`
  display: inline-block;
  margin-right: 2em;
  cursor: pointer;
`

const galleryImage = (builder, marks) => props => {
  const srcThumbnail = builder
    .image(props.node)
    .withOptions(props.options.imageOptions.thumbnail)
    .url()

  const srcFull = builder
    .image(props.node)
    .withOptions(props.options.imageOptions.full)
    .url()

  const image = (
    <Fragment>
      <img src={srcThumbnail} alt={props.node.caption} />
      {props.node.title ? (
        <BlockContent
          blocks={props.node.title}
          serializers={{
            marks,
          }}
        />
      ) : null}
    </Fragment>
  )

  return (
    <Lightbox
      src={srcFull}
      renderImage={props => <InlineDiv {...props}>{image}</InlineDiv>}
      title={props.node.title[0].children[0].text}
    />
  )
}

export default ({ sanityConfig, site, bhnSites }) => {
  const builder = imageUrlBuilder(sanityConfig)

  const marks = {
    link: link(bhnSites.map(({ url }) => url)),
    mailto: mailto(site.contactEmail, site.domain),
    sitename: sitename(site),
    gamename: gamename(site.game),
  }

  const types = {
    image: image(builder, marks),
    galleryImage: galleryImage(builder, marks),
  }

  return {
    types,
    marks,
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/utils/sanitySerializers.js